var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
import { xa } from '../../../utils/xa/xa';
import { TrackIdent } from '../../learnware/LearnwareEnums';
export class QuestionRating {
    parent;
    givenPoints = undefined;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get hasRated() {
        return !!this.givenPoints;
    }
    get ratingCount() {
        if (this.hasRated) {
            return this.question.ratingCount + 1;
        }
        return this.question.ratingCount;
    }
    get ratingStars() {
        return this.question.questionInfo.rating * 5;
    }
    rateQuestion(givenPoints) {
        this.givenPoints = givenPoints;
        xa.question.rateQuestion({ givenPoints, questionId: this.question.id });
        this.question.context.app.track.trackEvent({
            ident: TrackIdent.RateQuestion,
            question_id: this.question.id,
            answer_id: this.question.answer.id,
            value1: givenPoints.toString(),
        });
        /*  window.gtag('event', 'Rating', {
            event_category: 'Question',
            event_label: this.question.id_string,
            value: 1,
          }); */
    }
}
__decorate([
    observable
], QuestionRating.prototype, "givenPoints", void 0);
__decorate([
    action.bound
], QuestionRating.prototype, "rateQuestion", null);
